;(function (angular, _, moment) {
  'use strict'

  angular
    .module('kilo.routes.preferences')
    .controller('PreferencesController', PreferencesController)

  PreferencesController.$inject = [
    // Angular
    '$uibModal', '$state', '$http', '$rootScope', '$scope', '$timeout', '$location',

    // Config
    'urls',

    // Managers
    'InvoiceManager', 'QuoteManager', 'CreditNoteManager', 'OrderManager',
    'DefaultInvoiceTemplateManager', 'InvoiceTemplateManager',
    'DefaultQuoteTemplateManager', 'QuoteTemplateManager',
    'DefaultCreditNoteTemplateManager', 'CreditNoteTemplateManager',
    'CategoryManager', 'CustomFieldManager',
    'ProductTypeManager', 'VatManager', 'NumberManager',

    // Services
    'PreferencesService', 'DisplayService', 'SnackService',
    'SessionService', 'LedgerService', 'DatePickerService', 'ExportService', 'CategoryService', 'AppAccessService',

    // Resolve
    'tabIndex'

  ]

  function PreferencesController (
    // Angular
    $uibModal, $state, $http, $rootScope, $scope, $timeout, $location,

    // Config
    urls,

    // Managers
    InvoiceManager, QuoteManager, CreditNoteManager, OrderManager,
    DefaultInvoiceTemplateManager, InvoiceTemplateManager,
    DefaultQuoteTemplateManager, QuoteTemplateManager,
    DefaultCreditNoteTemplateManager, CreditNoteTemplateManager,
    CategoryManager, CustomFieldManager,
    ProductTypeManager, VatManager, NumberManager,

    // Services
    PreferencesService, DisplayService, SnackService,
    SessionService, LedgerService, DatePickerService, ExportService, CategoryService, AppAccessService,

    // Resolve
    tabIndex

  ) {
    var self = this

    var customRanges = []

    self.$onInit = () => {
      _.extend(self, {

        // Attributes
        debounce: 800,
        quoteDelays: quoteDelays,
        invoiceDelays: invoiceDelays,
        isAdmin: SessionService.isAdmin(),
        creditNoteDelays: creditNoteDelays,
        haveChorusAccess: false,
        redirs: [
          { label: 'Liste des produits', value: 'list' },
          { label: 'Nouveau produit', value: 'new' }
        ],
        periods: [
          { label: 'Année', value: 'year' },
          { label: 'Mois', value: 'month' },
          { label: 'Pas de périodicité', value: 'never' }
        ],
        months: [
          { label: 'Janvier', value: 0 },
          { label: 'Février', value: 1 },
          { label: 'Mars', value: 2 },
          { label: 'Avril', value: 3 },
          { label: 'Mai', value: 4 },
          { label: 'Juin', value: 5 },
          { label: 'Juillet', value: 6 },
          { label: 'Août', value: 7 },
          { label: 'Septembre', value: 8 },
          { label: 'Octobre', value: 9 },
          { label: 'Novembre', value: 10 },
          { label: 'Décembre', value: 11 }
        ],
        availableVats: [],
        customFields: {
          invoice: [],
          quote: [],
          creditnote: [],
          order: [],
          bpu: []
        },
        newVat: {},
        stripeAccess: urls.auth + '/stripe',
        paymentType: [
          { key: undefined, value: '--' },
          { key: 'cash', value: 'Liquide' },
          { key: 'wire_transfert', value: 'Virement' },
          { key: 'check', value: 'Chèque' },
          { key: 'direct-debit', value: 'Prélèvement' },
          { key: 'credit-card', value: 'Carte bancaire' },
          { key: 'gift-card', value: 'Bon cadeau' }
        ],
        autoSaveDelays: [
          5,
          10,
          15,
          20,
          25,
          30
        ],
        // Methods
        createPrefilledTemplate: createPrefilledTemplate,
        saveInvoiceParams: saveInvoiceParams,
        saveQuoteParams: saveQuoteParams,
        saveCreditNoteParams: saveCreditNoteParams,
        saveOrderParams: saveOrderParams,
        saveProductParams: saveProductParams,
        saveCompanyPrefs: saveCompanyPrefs,
        savePrefs: savePrefs,
        displayTemplate: displayTemplate,
        deleteTemplate: deleteTemplate,
        validateTag: validateTag,
        editCategory: editCategory,

        load: load,
        exportLedger: exportLedger,
        exportPayment: exportPayment,
        retryExport: retryExport,
        deleteErrors: deleteErrors,
        saveNumber: saveNumber,
        selectInsuranceEndDate: selectInsuranceEndDate,
        resetInsuranceDate: resetInsuranceDate,
        selectDateRange: selectDateRange,
        selectDateRangeCreditNote: selectDateRangeCreditNote,
        setDelayMonth: setDelayMonth,
        samePeriod: samePeriod
      })
      init()
    }
    $scope.$on('formModified', function () {
      if ($state.is('preferences')) {
        self.theForm.$dirty = true
        $timeout(function () {
          saveCompanyPrefs()
        })
      }
    })

    // Désinscrit le listener quand la page est détruite : sinon $rootScope garde
    // chaque instance du controller en mémoire et deleteErrors() tourne sur des scopes morts
    var unbindExportOk = $rootScope.$on('ledger-service:exportOk', function () {
      deleteErrors()
    })
    $scope.$on('$destroy', unbindExportOk)

    function init () {
      getNumbers()

      AppAccessService.getCompanyRights().then((rights) => {
        rights.forEach((right) => {
          if (right.appName === 'CHORUS' && right.hasAccess) self.haveChorusAccess = true
        })
      })
      // On ne fixe l'onglet actif (et le watch de synchro URL) qu'une seule
      // fois par instance de contrôleur. `init()` est rappelé après chaque
      // sauvegarde auto pour rafraîchir les données : sans ce garde, il
      // réécrirait `self.active` avec le `tabIndex` figé au chargement et
      // renverrait l'utilisateur sur l'onglet d'origine (bug de redirection
      // aléatoire vers Pennylane). Sur un vrai reload, `self.active` est
      // undefined → on repart du tabIndex résolu (retour sur le bon onglet).
      if (angular.isUndefined(self.active)) {
        self.active = self.isAdmin ? tabIndex : 1
        // Store current index in navigation bar to allow reload on correct tab
        $scope.$watch(() => self.active, () => $location.search('tabIndex', self.active))
      }
      if (LedgerService.isSetErrors()) {
        var errors = LedgerService.getErrors()
        self.vatErrors = _.filter(errors, function (elt) {
          return elt.type === 'MISSING_VAT_ACCOUNT'
        })
        self.typeErrors = _.filter(errors, function (elt) {
          return elt.type === 'MISSING_LINE_ACCOUNT'
        })
      }

      InvoiceManager.count().then(function (data) {
        self.totalInvoices = data.meta.total
      })

      QuoteManager.count().then(function (data) {
        self.totalQuotes = data.meta.total
      })

      CreditNoteManager.count().then(function (data) {
        self.totalCreditNotes = data.meta.total
      })

      OrderManager.count().then(function (data) {
        self.totalOrders = data.meta.total
      })

      PreferencesService.getInvoicePrefs().then(function (invoicePrefs) {
        self.invoicePrefs = invoicePrefs
        self.invoicePrefs.resetDate = self.invoicePrefs.resetDate || {
          month: 0,
          day: 1
        }
        if (!invoicePrefs?.emitPeriod?.start) {
          self.emitPeriod = null
        } else {
          self.emitPeriod = 'du ' + moment(invoicePrefs?.emitPeriod?.start).format('DD-MM-YYYY') + ' au ' + moment(invoicePrefs?.emitPeriod?.end).format('DD-MM-YYYY')
        }
      })

      PreferencesService.getQuotePrefs().then(function (quotePrefs) {
        self.quotePrefs = quotePrefs
        self.quotePrefs.resetDate = self.quotePrefs.resetDate || {
          month: 0,
          day: 1
        }
      })

      PreferencesService.getGeneralPrefs().then(function (generalPrefs) {
        self.generalPrefs = generalPrefs
      })

      PreferencesService.getCompanyPrefs().then(function (companyPrefs) {
        self.companyPrefs = companyPrefs
        self.allowArchiveAndRestore = !companyPrefs.enabledFeatures.allowArchiveAndRestore
        if (_.get(self.companyPrefs, 'companyInfo.insurance.endDate')) {
          self.companyPrefs.companyInfo.insurance.endDate = new Date(self.companyPrefs.companyInfo.insurance.endDate)
        }
        self.vats = _.map(self.companyPrefs.vats, String) || []
      })

      PreferencesService.getCreditNotePrefs().then(function (creditNotePrefs) {
        self.creditNotePrefs = creditNotePrefs
        self.creditNotePrefs.resetDate = self.creditNotePrefs.resetDate || {
          month: 0,
          day: 1
        }
        if (!creditNotePrefs?.emitPeriod?.start) {
          self.emitPeriodCreditNote = null
        } else {
          self.emitPeriodCreditNote = 'du ' + moment(creditNotePrefs?.emitPeriod?.start).format('DD-MM-YYYY') + ' au ' + moment(creditNotePrefs?.emitPeriod?.end).format('DD-MM-YYYY')
        }
      })

      PreferencesService.getOrderPrefs().then(function (orderPrefs) {
        self.orderPrefs = orderPrefs
        self.orderPrefs.resetDate = self.orderPrefs.resetDate || {
          month: 0,
          day: 1
        }
      })

      PreferencesService.getProductPrefs().then(function (productPrefs) {
        self.productPrefs = productPrefs
      })

      self.preFilledTemplates = self.preFilledTemplates || {}
      let query = InvoiceManager
        .query({
          conditions: {
            isModel: true
          }
        })
        .fields('_id modelTitle title lines')
        .limit(100)
      InvoiceManager.get(query).then(function (data) {
        self.preFilledTemplates.invoices = data.data
      })
      QuoteManager.get(query).then(function (data) {
        self.preFilledTemplates.quotes = data.data
      })

      self.templates = self.templates || {}
      InvoiceTemplateManager.get().then(function (d) {
        self.templates.invoices = _.filter(d.data, function (elt) {
          return !elt.isSituation
        })
        self.templates.situationInvoices = _.filter(d.data, function (elt) {
          return elt.isSituation === true
        })
      })

      DefaultInvoiceTemplateManager.get().then(function (d) {
        self.templates.defaultInvoices = _.filter(d.data, function (elt) {
          return !elt.isSituation
        })
        self.templates.defaultSituationInvoices = _.filter(d.data, function (elt) {
          return elt.isSituation === true
        })
      })

      QuoteTemplateManager.get().then(function (d) {
        self.templates.quotes = d.data
      })

      DefaultQuoteTemplateManager.get().then(function (d) {
        self.templates.defaultQuotes = d.data
      })

      CreditNoteTemplateManager.get().then(function (d) {
        self.templates.creditNotes = d.data
      })

      DefaultCreditNoteTemplateManager.get().then(function (d) {
        self.templates.defaultCreditNotes = d.data
      })
      CategoryService.getCategories().then((data) => {
        self.categories = data.map(category => category.label)
      })
    }

    function getNumbers () {
      NumberManager.get().then(function (data) {
        self.currentInvoiceNumber = _.find(data.data, { model: 'Invoice' }) ||
          NumberManager.create(
            {
              model: 'Invoice',
              currentNumber: 0
            })
        self.currentQuoteNumber = _.find(data.data, { model: 'Quote' }) ||
          NumberManager.create(
            {
              model: 'Quote',
              currentNumber: 0
            })
        self.currentCreditNoteNumber = _.find(data.data, { model: 'CreditNote' }) ||
          NumberManager.create(
            {
              model: 'CreditNote',
              currentNumber: 0
            })
        self.currentOrderNumber = _.find(data.data, { model: 'SufaOrder' }) ||
          NumberManager.create(
            {
              model: 'SufaOrder',
              currentNumber: 0
            })
      })
    }

    function handleError (d) {
      LedgerService.setErrors(d.data)
      self.vatErrors = _.filter(d.data, function (elt) {
        return elt.type === 'MISSING_VAT_ACCOUNT'
      })
      self.typeErrors = _.filter(d.data, function (elt) {
        return elt.type === 'MISSING_LINE_ACCOUNT'
      })
    }

    function exportLedger () {
      LedgerService.getGeneralLedger(handleError)
    }

    function exportPayment () {
      ExportService.paymentAsSpreadsheet()
    }

    function retryExport () {
      LedgerService.retryExport(handleError)
    }

    function load (model) {
      CustomFieldManager.get(CustomFieldManager.query().select(model, 'model')).then(function (data) {
        self.customFields[model] = data.data || []
      })
    }

    function displayTemplate (type, action, template) {
      return $uibModal.open({
        size: 'lg',
        bindToController: true,
        resolve: {
          availableQuoteTemplates: function () {
            return angular.copy(self.templates.quotes)
          },
          availableInvoiceTemplates: function () {
            return angular.copy(self.templates.invoices)
          },
          availableSituationInvoiceTemplates: function () {
            return angular.copy(self.templates.situationInvoices)
          },
          availableCreditNoteTemplates: function () {
            return angular.copy(self.templates.creditNotes)
          },
          template: function () {
            if (template) {
              return angular.copy(template)
            } else {
              var newTemplate = {
                label: '',
                content: '<!doctype html>\n<html>\n<head>\n\n</head>\n<body>\n\n</body>\n<html>',
                options: []
              }
              if (type === 'situation') newTemplate.isSituation = true
              if (type === 'devis') {
                return QuoteTemplateManager.create(newTemplate)
              } else if (type === 'facture' || type === 'situation') {
                return InvoiceTemplateManager.create(newTemplate)
              } else if (type === 'avoir') {
                return CreditNoteTemplateManager.create(newTemplate)
              }
            }
          },
          type: function () { return type },
          action: function () { return action }
        },
        templateUrl: '/app/modules/preferences/display-template/display-template.html',
        controller: 'DisplayTemplateController',
        controllerAs: 'ctrl',
        backdrop: 'static'
      }).result.then(function (template) {
        self.loading = true
        template.save().then(function () {
          SnackService.snack({
            text: 'Modèle sauvegardé !',
            delay: 5000
          })
          $state.go('preferences', { tabIndex: self.active })
          init()
          self.loading = false
        })
      })
    }

    function deleteTemplate (template) {
      return $uibModal.open({
        size: 'lg',
        templateUrl: '/app/modules/preferences/display-template/delete-template.html',
        controller: 'DeleteTemplateController',
        controllerAs: 'del'
      }).result.then(function (res) {
        if (res === true) {
          self.loading = true
          if (template.modelTitle) {
            template.archive().then(function () {
              SnackService.snack({
                text: 'Modèle pré-rempli supprimé !',
                delay: 5000
              })
              $state.go('preferences', { tabIndex: self.active })
              init()
              self.loading = false
            })
          } else {
            template.remove().then(function () {
              SnackService.snack({
                text: 'Modèle supprimé !',
                delay: 5000
              })
              $state.go('preferences', { tabIndex: self.active })
              init()
              self.loading = false
            })
          }
        }
      })
    }

    function createPrefilledTemplate (type) {
      switch (type) {
        case 'invoice':
          let invoice = InvoiceManager.create({})
          invoice.isModel = true
          return $state.go('invoice.newTemplate', { initParams: invoice })
        case 'quote':
          let quote = QuoteManager.create({})
          quote.isModel = true
          return $state.go('quote.newTemplate', { initParams: quote })
      }
    }

    function editCategory (category) {
      return CategoryService.editCategory(category).then(() => {
        $state.go('preferences', { tabIndex: self.active })
        init()
      })
    }

    function validateTag (item) {
      if (isNaN(parseFloat(item))) {
        var index = self.vats.indexOf(item)
        self.vats.splice(index, 1)
      } else {
        saveCompanyPrefs()
      }
    }

    function saveCompanyPrefs () {
      self.loading = true
      self.companyPrefs.vats = _.map(self.vats, function (elt) {
        return parseFloat(elt.replace(',', '.'))
      })
      self.companyPrefs.save().then(function () {
        SnackService.snack({
          text: 'Préférences générales enregistrées !',
          delay: 5000
        })
        self.theForm.$setPristine()
        $state.go('preferences', { tabIndex: self.active })
        init()
        self.loading = false
      })

      $rootScope.$broadcast('refreshCompanyPrefs')
    }

    function saveNumber (number) {
      DisplayService.displayConfirm('Modifier la numérotation', 'Voulez-vous vraiment modifier la numérotation ?')
        .then(function () {
          number.save()
        }, getNumbers) // <- fallback if the user answered NO
    }

    function saveInvoiceParams () {
      self.loading = true
      self.invoicePrefs.save().then(function () {
        SnackService.snack({
          text: 'Préférences factures enregistrées !',
          delay: 5000
        })
        self.invoiceForm.$setPristine()
        $state.go('preferences', { tabIndex: self.active })
        init()
        self.loading = false
      })
    }

    function saveQuoteParams () {
      self.loading = true
      self.quotePrefs.save().then(function () {
        SnackService.snack({
          text: 'Préférences devis enregistrées !',
          delay: 5000
        })
        self.quoteForm.$setPristine()
        $state.go('preferences', { tabIndex: self.active })
        init()
        self.loading = false
      })
    }

    function saveCreditNoteParams () {
      self.loading = true
      self.creditNotePrefs.save().then(function () {
        SnackService.snack({
          text: 'Préférences avoirs enregistrées !',
          delay: 5000
        })
        self.creditNoteForm.$setPristine()
        $state.go('preferences', { tabIndex: self.active })
        init()
        self.loading = false
      })
    }

    function saveOrderParams () {
      self.loading = true
      self.orderPrefs.save().then(function () {
        SnackService.snack({
          text: 'Préférences chantiers enregistrés !',
          delay: 5000
        })
        self.orderForm.$setPristine()
        $state.go('preferences', { tabIndex: self.active })
        init()
        self.loading = false
      })
    }

    function saveProductParams () {
      self.loading = true
      self.productPrefs.save().then(function () {
        SnackService.snack({
          text: 'Préférences produits enregistrées !',
          delay: 5000
        })
        self.productForm.$setPristine()
        $state.go('preferences', { tabIndex: self.active })
        init()
        self.loading = false
      })
    }

    function deleteErrors () {
      LedgerService.deleteErrors()
      delete self.vatErrors
      delete self.typeErrors
    }

    function savePrefs () {
      self.loading = true
      self.generalPrefs.save().then(function () {
        SnackService.snack({
          text: 'Préférences utilisateur enregistrées !',
          delay: 5000
        })
        $state.go('preferences', { tabIndex: self.active })
        init()
        self.loading = false
      })
    }

    function selectInsuranceEndDate () {
      DatePickerService.getRange(_.get(self.companyPrefs, 'companyInfo.insurance.endDate')).then(function (date) {
        date.utcOffset(0, true)
        _.set(self.companyPrefs, 'companyInfo.insurance.endDate', date.toDate())
        self.theForm.$setDirty()
        saveCompanyPrefs()
      })
    }

    function resetInsuranceDate () {
      _.set(self.companyPrefs, 'companyInfo.insurance.endDate', null)
      self.theForm.$setDirty()
      saveCompanyPrefs()
    }

    function selectDateRange () {
      DatePickerService.getRange(self.invoicePrefs.emitPeriod, { showRanged: true, customSelectOptions: customRanges }).then(function (dates) {
        _.set(self.invoicePrefs, 'emitPeriod.start', dates.start.toDate())
        _.set(self.invoicePrefs, 'emitPeriod.end', dates.end.toDate())
        saveInvoiceParams()
      })
    }

    function selectDateRangeCreditNote () {
      DatePickerService.getRange(self.creditNotePrefs.emitPeriod, { showRanged: true, customSelectOptions: customRanges }).then(function (dates) {
        _.set(self.creditNotePrefs, 'emitPeriod.start', dates.start.toDate())
        _.set(self.creditNotePrefs, 'emitPeriod.end', dates.end.toDate())
        saveCreditNoteParams()
      })
    }

    function samePeriod (type) {
      if (type === 'invoice') {
        _.set(self.invoicePrefs, 'emitPeriod.start', self.creditNotePrefs.emitPeriod.start)
        _.set(self.invoicePrefs, 'emitPeriod.end', self.creditNotePrefs.emitPeriod.end)
        saveInvoiceParams()
      } else {
        _.set(self.creditNotePrefs, 'emitPeriod.start', self.invoicePrefs.emitPeriod.start)
        _.set(self.creditNotePrefs, 'emitPeriod.end', self.invoicePrefs.emitPeriod.end)
        saveCreditNoteParams()
      }
    }

    function setDelayMonth (name) {
      self.invoicePrefs[name] = false
      self.saveInvoiceParams()
    }

    var delays = [
      { label: '10', value: 10 },
      { label: '15', value: 15 },
      { label: '30', value: 30 },
      { label: '45', value: 45 },
      { label: '53', value: 53 },
      { label: '60', value: 60 },
      { label: '90', value: 90 },
      { label: '120', value: 120 },
      { label: '180', value: 180 }
    ]

    var quoteDelays = angular.copy(delays)
    var invoiceDelays = angular.copy(delays)
    var creditNoteDelays = angular.copy(delays)
    invoiceDelays.unshift({ label: 'À réception de facture', value: 0 })
    creditNoteDelays.unshift({ label: 'À réception de l\'avoir', value: 0 })
  }
})(window.angular, window._, window.moment)
